/**
 * The web client's binding of the shared domain map.
 *
 * The map itself lives in `@core` because mobile had its own 161-line copy of
 * it, "kept deliberately in step" by hand. Only the HOST differs per client, so
 * only the host lives here.
 */
// API_DOMAINS is imported AS WELL AS re-exported below: `export { X } from "…"`
// creates no local binding, so `backendOf` could not see it otherwise.
import { API_DOMAINS, apiUrl as coreApiUrl, domainBaseUrl as coreDomainBaseUrl } from "@core";

export {
  API_DOMAINS,
  BACKEND_PREFIX,
  type ApiBackend,
  type ApiDomain,
  type DomainConfig,
  type QueryValue,
} from "@core";

/** Empty string = same origin as the SPA, which nginx and the Vite proxy both provide. */
export const API_HOST: string = (import.meta.env?.VITE_API_HOST ?? "").replace(/\/+$/, "");

export function domainBaseUrl(domain: Parameters<typeof coreDomainBaseUrl>[0], host = API_HOST) {
  return coreDomainBaseUrl(domain, host);
}

export function apiUrl(
  domain: Parameters<typeof coreApiUrl>[0],
  path = "",
  query?: Parameters<typeof coreApiUrl>[2],
  host = API_HOST,
) {
  return coreApiUrl(domain, path, query, host);
}

export function backendOf(domain: Parameters<typeof coreApiUrl>[0]) {
  return API_DOMAINS[domain].backend;
}
